import React from "react";
import { Modal } from "react-bootstrap";
import { FiX } from "react-icons/fi";

function Exco1({ show, onClose, onOpen }) {
  return (
    <div>
      <div>
        <Modal
          size="lg"
          show={show}
          onHide={onClose}
          // backdrop="static"
          aria-labelledby="example-modal-sizes-title-lg"
          keyboard={false}
          animation={true}
          centered
        >
          <Modal.Body>
            <div className="Solera__Cont">
              <FiX className="Solera__Close" onClick={onClose} />
            </div>

            <div className="Exoc-Name">Emmanuel Chilaka</div>
            <div className="Exco-Tittle">Treasurer</div>
            <br />

            <div className="Excos-Bio">
              Emmanuel Chilaka is a dynamic entrepreneur and business leader
              known for his exemplary leadership as the CEO of DHS Recruitment
              Ltd. With a strong background in property development and finance,
              he has successfully built a diverse portfolio of holdings in these
              sectors. <br /> <br />
              Emmanuel is also recognized as a serial investor in financial
              instruments and forex, with a keen eye for strategic opportunities
              in the market. His passion for mentoring and developing career
              paths has positively impacted many individuals in their
              professional journeys. <br /> <br />A proud member of the Unilag
              Alumni UK since 2016, Emmanuel has actively contributed to the
              association's growth and success. He currently serves as a vital
              member of the executive committee, holding the position of
              treasurer and bringing his financial expertise to the
              organization's operations. Emmanuel Chilaka's commitment to
              excellence and dedication to empowering others make him a
              respected figure in both business and alumni circles. <br />{" "}
              <br />I was the immediate past executive and served as second vice
              president of the UK 🇬🇧 chapter of the alumni from 2017 to 2022
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
}

export default Exco1;
